//================================================================
//  Page: Requests
//================================================================

//  Purpose: This page shows all requests at each stage

//================================================================


// Libraries
import React, { useEffect, useReducer ,useContext} from 'react';

// Contexts
import { SetToast } from '../../Library/GlobalContexts';

// Components
import PageComponent from '../../Components/PageComponent/PageComponent';
import TabView from '../../Components/TabView/TabView';

// Tabs
import Unassigned from './Tabs/Unassigned';
import InProgress from './Tabs/InProgress';
import Completed from './Tabs/Completed';
import Cancelled from './Tabs/Cancelled';
import All from './Tabs/All';

// Functions
import QueryListener from '../../Library/QueryListener';

// Images

// CSS
import './Requests.css';


export default function Requests() {

  //------------------------------------------------------
  //  useContext
  //------------------------------------------------------

  const setToast = useContext(SetToast);

  //------------------------------------------------------
  //  useReducer
  //------------------------------------------------------

  // Used to store the total requests per stage/view
  const [requests, setRequests] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      'unassignedRequests': [],
      'unassignedRequestsFiltered': [],
      'inProgressRequests': [],
      'inProgressRequestsFiltered': [],
      'completedRequests': [],
      'completedRequestsFiltered': [],
      'cancelledRequests': [],
      'cancelledRequestsFiltered': [],
      'allRequests': [],
      'allRequestsFiltered': [],
    }
  );

  //------------------------------------------------------
  //  useEffects
  //------------------------------------------------------

  // Query Listener
  // - Get all requests that are in progress
  useEffect(() => {

    function onLoadChange(documents) {
      setRequests({
        'inProgressRequests': documents
      });
    }

    function onError(error) {
      console.log(error);

      // Error on Toast
      setToast({
        'type': 'error',
        'message': 'Error loading requests'
      });
    }

    const unsubscribe = QueryListener('requests', [
      ['assignmentgroup', '==', 'Procurement'],
      ['tasktype', '==', 'Procurement'],
      ['status', '==', 'In Progress'],
    ], onLoadChange, onLoadChange, onError);

    return () => {
      unsubscribe();
    };

    // eslint-disable-next-line
  }, [])

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <PageComponent
      body={
        <TabView
          defaultView={1}

          //------------------------------------------------------
          //  Unassigned
          //------------------------------------------------------

          oneTitle={
            <div className='flex flex-row gap-2'>
              Unassigned
              <div className='flex items-center justify-center h-[22px] w-[22px] rounded-full bg-[#006866] text-white text-[12px] font-bold' hidden={requests?.unassignedRequests?.length === 0}>
                {requests?.unassignedRequests?.length}
              </div>
            </div>
          }
          oneRoute={'/requests?view=unassigned'}
          oneContent={
            <Unassigned
              requests={requests}
              setRequests={setRequests}
            ></Unassigned>
          }

          //------------------------------------------------------
          //  In Progress
          //------------------------------------------------------

          twoTitle={
            <div className='flex flex-row gap-2'>
              In Progress
              <div className='flex items-center justify-center h-[22px] w-[22px] rounded-full bg-[#006866] text-white text-[12px] font-bold' hidden={requests?.inProgressRequests?.length === 0}>
                {requests?.inProgressRequests?.length}
              </div>
            </div>
          }
          twoRoute={'/requests?view=inprogress'}
          twoContent={
            <InProgress
              requests={requests}
              setRequests={setRequests}
            ></InProgress>
          }

          //------------------------------------------------------
          //  Completed
          //------------------------------------------------------

          threeTitle={'Completed'}
          threeRoute={'/requests?view=completed'}
          threeContent={
            <Completed
              requests={requests}
              setRequests={setRequests}
            ></Completed>
          }

          //------------------------------------------------------
          //  Cancelled
          //------------------------------------------------------

          fourTitle={'Cancelled'}
          fourRoute={'/requests?view=cancelled'}
          fourContent={
            <Cancelled
              requests={requests}
              setRequests={setRequests}
            ></Cancelled>
          }

          //------------------------------------------------------
          //  All
          //------------------------------------------------------

          fiveTitle={'All'}
          fiveRoute={'/requests?view=all'}
          fiveContent={
            <All
              requests={requests}
              setRequests={setRequests}
            ></All>
          }

        ></TabView>
      }
    ></PageComponent>
  )
}
